import { useEffect } from "react";
import { useMsal, useAccount } from "@azure/msal-react";

import useUrlQueryParams from "../url/UrlQueryService";
import { registerService } from "../service-provider/ServiceRegistry";
import { appSessionStorage } from "../storage/SessionStorageService";
import { authentication } from "./Authentication";

export const VIEWER_TOKEN_KEY = "viewerAuth";

export function useAuthService() {
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const { authToken } = useUrlQueryParams();

  useEffect(() => {
    const viewerAuthToken = authToken || appSessionStorage.getStorageItem(VIEWER_TOKEN_KEY);

    authentication.loginAndObtainToken(instance, account, viewerAuthToken, inProgress);
  }, [account, authToken, inProgress, instance]);
}

export default registerService(useAuthService);
